import '../stimulus'
import '../turbo/stream_actions/dispatch_event'
import '../utils/events'
import '../utils/file'
import '../utils/templates'
import '../utils/visibility'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as ActiveStorage from '@rails/activestorage'
import { Turbo } from '@hotwired/turbo-rails'

ActiveStorage.start()
Turbo.session.drive = false
